import { useMemo } from 'react'
import { numberFormat } from 'shared/util'

import { ServicesResult } from "interface/kojin/log"

import { Stack, StackProps } from "@mui/material"
import { PinIcon } from 'shared/icons'
import { colors } from "shared/colors"

import { ValueSpan, ValueSpanProps } from 'components/controls/valueSpan'

const joinServices: { [index: string]: string[] } = {
	'news': ['news', 'kiji', 'slide'],
	'mrplus': ['mrplus', 'mrplus_client']
}

type ServiceChipProps = {
	service: string
	count: number
	active: boolean
} & ValueSpanProps
const ServiceChip = ({
	service,
	count,
	active,
	...others
}: ServiceChipProps) => {
	return (
		<ValueSpan
			{...others}
			color={active ? undefined : "disabled"}
			pin={(
				<PinIcon
					color={active ? undefined : "disabled"}
					style={active ? {
						color: (
							service === 'news' ? colors.news.main :
							service === 'drsPicksNews' ? colors.news.main :
							service === 'mrplus' ? colors.mrp.main :
							service === 'live' ? colors.live.main :
							service === 'dvd' ? colors.other.main :
							service === 'drug' ? colors.other.main :
							undefined
						)
					} : undefined}
				/>
			)}
			prefix={(
				service === 'news' ? "NEWS" :
				service === 'drsPicksNews' ? "DrsPicks" :
				service === 'mrplus' ? "MRPlus" :
				service === 'live' ? "講演会" :
				service === 'dvd' ? "DVD" :
				service === 'drug' ? "薬品検索" :
				undefined
			)}
			text={numberFormat(count)}
			prefixProps={{ whiteSpace: 'nowrap' }}
		/>
	)
}

type ServiceChipsProps = {
	services: ServicesResult[]
	currentService: string[]
	setCurrentService: (service: string[]) => void
} & StackProps
export const ServiceChips = ({
	services,
	currentService,
	setCurrentService,
	...others
}: ServiceChipsProps) => {
	const adjustedServices = useMemo(
		() => {
			const adjustedServices: ServicesResult[] = []
			for(const { service, count } of services) {
				const join = Object.keys(joinServices).find(key => joinServices[key]?.includes(service) ?? false)
				if (join) {
					const exist = adjustedServices.find(e => e.service === join)
					if (exist) {
						exist.count += count
					} else {
						adjustedServices.push({ service: join, count })
					}
					continue
				}
				adjustedServices.push({ service, count })
			}
			adjustedServices.sort((a, b) => b.count - a.count)
			return adjustedServices
		},
		[services]
	)
	return (
		<Stack
			direction='row'
			flexWrap="wrap"
			useFlexGap
			{...others}
		>
			{adjustedServices.map(({ service, count }, i) => (
				<ServiceChip
					key={`service-${i}`}
					service={service}
					count={count}
					active={(currentService.length === 0 || currentService.includes(service)) ? true : false}
					stackProps={{
						paddingX: 1,
						onClick: () => {
							setCurrentService(
								currentService.includes(service) ? [] :
								joinServices[service] ?? [service]
							)
						},
						sx: { cursor: 'pointer ' }
					}}
				/>
			))}
		</Stack>
	)
}
